import gql from 'graphql-tag';

export * from '../../../../src/graphql/queries';
export const PrivatePosts = gql`
  query PrivatePosts(
    $userIds: [ID!]!
    $filter: PrivatePostFilter!
    $after: String
  ) {
    privatePosts(userIds: $userIds, filter: $filter, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
`;

export const UserPosts = gql`
  query UserPosts(
    $userIds: [ID!]!
    $projectId: ID!
    $cohortId: ID
    $filter: PrivatePostFilter!
    $after: String
  ) {
    userPosts(
      userIds: $userIds
      projectId: $projectId
      cohortId: $cohortId
      filter: $filter
      after: $after
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...PostDetails
        }
      }
    }
  }
`;

export const Conversations = gql`
  query Conversations($first: Int, $after: String) {
    conversations(first: $first, after: $after) {
      edges {
        node {
          conversationId
          userIds
          latestMessageText
          latestMessageTime
          latestMessageUserId
          hasUnread
        }
      }
    }
  }
`;
